import axios from "axios";

import type {
    AssignCompanyParams,
    CompanyGroupRepository,
    CreateCompanyGroupParams,
    CurrentCompanyGroup,
    ICompanyGroup,
    ICompanyGroupMember,
    SharedFields,
    UpdateCompanyGroupParams,
} from ".";

// REACT_APP_API_ENDPOINT already includes `/v1`.
const baseUrl = () => import.meta.env.REACT_APP_API_ENDPOINT + "/company-group";

export class CompanyGroupApi implements CompanyGroupRepository {
    async fetchCompanyGroups(): Promise<ICompanyGroup[]> {
        const response = await axios.get(baseUrl());
        return response.data.data;
    }

    async createCompanyGroup(params: CreateCompanyGroupParams): Promise<{ id: number; name: string }> {
        const response = await axios.post(baseUrl(), params);
        return response.data.data;
    }

    async updateCompanyGroup(params: UpdateCompanyGroupParams): Promise<ICompanyGroup> {
        const response = await axios.put(`${baseUrl()}/${params.id}`, { name: params.name });
        return response.data.data;
    }

    async deleteCompanyGroup(id: number): Promise<void> {
        await axios.delete(`${baseUrl()}/${id}`);
    }

    async fetchGroupCompanies(groupId: number): Promise<ICompanyGroupMember[]> {
        const response = await axios.get(`${baseUrl()}/${groupId}/companies`);
        return response.data.data;
    }

    async assignCompany({ groupId, companyId }: AssignCompanyParams): Promise<void> {
        await axios.post(`${baseUrl()}/${groupId}/companies`, { companyId });
    }

    async unassignCompany({ groupId, companyId }: AssignCompanyParams): Promise<void> {
        await axios.delete(`${baseUrl()}/${groupId}/companies/${companyId}`);
    }

    async fetchSharedFields(groupId: number): Promise<SharedFields> {
        const response = await axios.get(`${baseUrl()}/${groupId}/shared-fields`);
        return response.data.data;
    }

    async setSharedFields(groupId: number, fields: string[]): Promise<{ fields: string[] }> {
        const response = await axios.put(`${baseUrl()}/${groupId}/shared-fields`, { fields });
        return response.data.data;
    }

    // Accessible to publisher users
    async getCurrent(): Promise<CurrentCompanyGroup> {
        const response = await axios.get(`${import.meta.env.REACT_APP_API_ENDPOINT}/company/group`);
        return response.data.data;
    }
}
